import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import { mergeField } from '@/utils'

const module = 'users'
let doc = {
  list: {
    name: 'Utilisateurs',
    headers: [
      { label: 'Prénom', value: 'first_name' },
      { label: 'Nom', value: 'last_name' },
      { label: 'Roles', value: 'userRoles', orig: 'roles' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['users.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['users.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    search: [
    ],
  },

  form: {
    name: 'Utilisateur',
    fields: [
      { label: 'Prénom', type: 'text', name: 'first_name' },
      { label: 'Nom', type: 'text', name: 'last_name' },
      { label: 'Identifiant', type: 'text', name: 'username', hint: "l'identifiant de l'utilisateur pour l'authentification" },
      { label: 'Mot de passe', type: 'password', name: 'password', hint: 'Minimum 7 caractères' },
      {
        label: 'Roles',
        type: 'multilist',
        from: 'name',
        source: 'roles',
        name: 'roles',
        hint: 'Les groupes auquels cet utilisateur appartient',
      },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['users.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        isFlat: true,
        scope: ['users.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
  },

  postprocess: item => {
    let userRoles = item.roles
      ? mergeField(item.roles, 'name')
      : ''
    return {
      ...item,
      userRoles,
    }
  },

  params: {
    fetchAll: {include: 'roles'},
    fetchOne: {include: 'roles'},
  },
}

export default crudmaker(module, apiClient, doc)
